export default "__VITE_ASSET__DKuwzCq6__$_?url__"